"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const react_1 = __importStar(require("react"));
const grapesjs_1 = __importDefault(require("grapesjs"));
const grapesjs_react_1 = require("grapesjs-react");
const grapesjs_plugin_export_1 = __importDefault(require("grapesjs-plugin-export"));
require("grapesjs-preset-webpage");
// @ts-expect-error FIXME: Using the exported min file for now.
const index_ts_1 = __importDefault(require("./grapesjs-plugin-s3/index.ts")); // eslint-disable-line import/extensions
const ShipmentTracking_1 = __importDefault(require("./ShipmentTracking"));
const utils_1 = require("./ShipmentTracking/utils");
//
// assets
//
const defaultFonts_1 = require("./defaultFonts");
//
// config
//
const panels_1 = __importDefault(require("./panels"));
const sectors_1 = __importDefault(require("./sectors"));
//
// styles
//
require("grapesjs/dist/css/grapes.min.css");
const GlobalStyle_1 = __importDefault(require("./GlobalStyle"));
// @ts-expect-error FIXME: Plugins missing from GrapesJS.
grapesjs_1.default.plugins.add('gjs-plugin-s3', index_ts_1.default);
const Editor = (props, ref) => {
    const editorRef = (0, react_1.useRef)({
        editor: null
    });
    const { assetData, fonts, onAddFont, onUpdateEditor, uploadAsset, uploadComplete } = props;
    const { htmlContent = '<div></div>' } = props;
    const formattedFonts = defaultFonts_1.defaultFonts.concat(fonts).map((font) => {
        return {
            fontFamily: font.node.family,
            fontName: font.node.name,
            source: font.node.url,
            fontWeight: []
        };
    });
    const customFonts = formattedFonts.filter((font) => font.source !== '');
    (0, react_1.useImperativeHandle)(ref, () => { var _a; return ({ editor: (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor }); });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyle_1.default, null),
        react_1.default.createElement(grapesjs_react_1.GrapesjsReact
        // eslint-disable-next-line react/jsx-first-prop-new-line
        , { 
            // eslint-disable-next-line react/jsx-first-prop-new-line
            allowScripts: 1, assetManager: { assets: assetData }, canvas: {
                styles: customFonts.map((font) => font.source)
            }, fromElement: true, height: 'calc(100% - 60px)', id: 'gjs', onInit: function (editor) {
                editorRef.current.editor = editor;
                if (!editor) {
                    return;
                }
                (0, panels_1.default)(editor, {
                    command: {
                        id: 'add-font',
                        title: 'Add Font',
                        className: 'fa fa-font',
                        onSubmit: onAddFont
                    }
                });
                (0, sectors_1.default)(editor, {
                    fonts: formattedFonts.map(({ fontFamily, fontName }) => ({
                        value: fontFamily,
                        name: fontName
                    })),
                    customFonts: customFonts.map((font) => font.fontFamily),
                    customFontWeights: customFonts.reduce((acc, obj) => (Object.assign(Object.assign({}, acc), { [obj.fontFamily]: obj.fontWeight })), {})
                });
                // @ts-expect-error FIXME: Find different editor event.
                editor.on('change:changesCount', () => {
                    const htmlString = `${editor.getHtml()}<style>${editor.getCss()}</style>`;
                    onUpdateEditor(htmlString);
                });
            }, plugins: [
                grapesjs_plugin_export_1.default,
                'gjs-preset-webpage',
                'gjs-plugin-s3',
                ShipmentTracking_1.default
            ], pluginsOpts: {
                grapesjsPluginExport: {
                    root: (0, utils_1.getRootConfig)()
                },
                'gjs-preset-webpage': {
                    modalImportTitle: 'Import Template',
                    modalImportLabel: '<div style="margin-bottom: 10px; font-size: 13px;">Paste here your HTML/CSS and click Import</div>',
                    modalImportContent: function (editor) {
                        return `${editor.getHtml()}<style>${editor.getCss()}</style>`;
                    },
                    filestackOpts: null,
                    aviaryOpts: false,
                    blocksBasicOpts: { flexGrid: 1 },
                    customStyleManager: [
                        {
                            name: 'General',
                            properties: [
                                {
                                    extend: 'float',
                                    type: 'radio',
                                    default: 'none',
                                    options: [
                                        { value: 'none', className: 'fa fa-times' },
                                        { value: 'left', className: 'fa fa-align-left' },
                                        { value: 'right', className: 'fa fa-align-right' }
                                    ]
                                },
                                'display',
                                { extend: 'position', type: 'select' },
                                'top',
                                'right',
                                'left',
                                'bottom'
                            ]
                        },
                        {
                            name: 'Dimension',
                            open: false,
                            properties: [
                                'width',
                                {
                                    id: 'flex-width',
                                    type: 'integer',
                                    name: 'Width',
                                    units: ['px', '%'],
                                    property: 'flex-basis',
                                    toRequire: 1
                                },
                                'height',
                                'max-width',
                                'min-height',
                                'margin',
                                'padding'
                            ]
                        },
                        {
                            name: 'Typography',
                            open: false,
                            properties: [
                                'font-family',
                                'font-size',
                                'font-weight',
                                'letter-spacing',
                                'color',
                                'line-height',
                                {
                                    extend: 'text-align',
                                    options: [
                                        {
                                            id: 'left',
                                            label: 'Left',
                                            className: 'fa fa-align-left'
                                        },
                                        {
                                            id: 'center',
                                            label: 'Center',
                                            className: 'fa fa-align-center'
                                        },
                                        {
                                            id: 'right',
                                            label: 'Right',
                                            className: 'fa fa-align-right'
                                        },
                                        {
                                            id: 'justify',
                                            label: 'Justify',
                                            className: 'fa fa-align-justify'
                                        }
                                    ]
                                },
                                {
                                    property: 'text-decoration',
                                    type: 'radio',
                                    default: 'none',
                                    options: [
                                        { id: 'none', label: 'None', className: 'fa fa-times' },
                                        {
                                            id: 'underline',
                                            label: 'underline',
                                            className: 'fa fa-underline'
                                        },
                                        {
                                            id: 'line-through',
                                            label: 'Line-through',
                                            className: 'fa fa-strikethrough'
                                        }
                                    ]
                                },
                                'text-shadow'
                            ]
                        },
                        {
                            name: 'Decorate',
                            open: false,
                            properties: [
                                'opacity',
                                'border-radius',
                                'border',
                                'box-shadow',
                                'background-color',
                                'background'
                            ]
                        },
                        {
                            name: 'Extra',
                            open: false,
                            buildProps: ['transition', 'perspective', 'transform']
                        },
                        {
                            name: 'Flex',
                            open: false,
                            properties: [
                                {
                                    name: 'Flex Container',
                                    property: 'display',
                                    type: 'select',
                                    defaults: 'block',
                                    list: [
                                        { value: 'block', name: 'Disable' },
                                        { value: 'flex', name: 'Enable' }
                                    ]
                                },
                                {
                                    name: 'Flex Parent',
                                    property: 'label-parent-flex',
                                    type: 'integer'
                                },
                                {
                                    name: 'Direction',
                                    property: 'flex-direction',
                                    type: 'radio',
                                    defaults: 'row',
                                    list: [
                                        {
                                            value: 'row',
                                            name: 'Row',
                                            className: 'icons-flex icon-dir-row',
                                            title: 'Row'
                                        },
                                        {
                                            value: 'row-reverse',
                                            name: 'Row reverse',
                                            className: 'icons-flex icon-dir-row-rev',
                                            title: 'Row reverse'
                                        },
                                        {
                                            value: 'column',
                                            name: 'Column',
                                            title: 'Column',
                                            className: 'icons-flex icon-dir-col'
                                        },
                                        {
                                            value: 'column-reverse',
                                            name: 'Column reverse',
                                            title: 'Column reverse',
                                            className: 'icons-flex icon-dir-col-rev'
                                        }
                                    ]
                                },
                                {
                                    name: 'Justify',
                                    property: 'justify-content',
                                    type: 'radio',
                                    defaults: 'flex-start',
                                    list: [
                                        {
                                            value: 'flex-start',
                                            className: 'icons-flex icon-just-start',
                                            title: 'Start'
                                        },
                                        {
                                            value: 'flex-end',
                                            title: 'End',
                                            className: 'icons-flex icon-just-end'
                                        },
                                        {
                                            value: 'space-between',
                                            title: 'Space between',
                                            className: 'icons-flex icon-just-sp-bet'
                                        },
                                        {
                                            value: 'space-around',
                                            title: 'Space around',
                                            className: 'icons-flex icon-just-sp-ar'
                                        },
                                        {
                                            value: 'center',
                                            title: 'Center',
                                            className: 'icons-flex icon-just-sp-cent'
                                        }
                                    ]
                                },
                                {
                                    name: 'Align',
                                    property: 'align-items',
                                    type: 'radio',
                                    defaults: 'center',
                                    list: [
                                        {
                                            value: 'flex-start',
                                            title: 'Start',
                                            className: 'icons-flex icon-al-start'
                                        },
                                        {
                                            value: 'flex-end',
                                            title: 'End',
                                            className: 'icons-flex icon-al-end'
                                        },
                                        {
                                            value: 'stretch',
                                            title: 'Stretch',
                                            className: 'icons-flex icon-al-str'
                                        },
                                        {
                                            value: 'center',
                                            title: 'Center',
                                            className: 'icons-flex icon-al-center'
                                        }
                                    ]
                                },
                                {
                                    name: 'Flex Children',
                                    property: 'label-parent-flex',
                                    type: 'integer'
                                },
                                {
                                    name: 'Order',
                                    property: 'order',
                                    type: 'integer',
                                    defaults: 0,
                                    min: 0
                                },
                                {
                                    name: 'Flex',
                                    property: 'flex',
                                    type: 'composite',
                                    properties: [
                                        {
                                            name: 'Grow',
                                            property: 'flex-grow',
                                            type: 'integer',
                                            defaults: 0,
                                            min: 0
                                        },
                                        {
                                            name: 'Shrink',
                                            property: 'flex-shrink',
                                            type: 'integer',
                                            defaults: 0,
                                            min: 0
                                        },
                                        {
                                            name: 'Basis',
                                            property: 'flex-basis',
                                            type: 'integer',
                                            units: ['px', '%', ''],
                                            unit: '',
                                            defaults: 'auto'
                                        }
                                    ]
                                },
                                {
                                    name: 'Align',
                                    property: 'align-self',
                                    type: 'radio',
                                    defaults: 'auto',
                                    list: [
                                        {
                                            value: 'auto',
                                            name: 'Auto'
                                        },
                                        {
                                            value: 'flex-start',
                                            title: 'Start',
                                            className: 'icons-flex icon-al-start'
                                        },
                                        {
                                            value: 'flex-end',
                                            title: 'End',
                                            className: 'icons-flex icon-al-end'
                                        },
                                        {
                                            value: 'stretch',
                                            title: 'Stretch',
                                            className: 'icons-flex icon-al-str'
                                        },
                                        {
                                            value: 'center',
                                            title: 'Center',
                                            className: 'icons-flex icon-al-center'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                'gjs-plugin-s3': {
                    imgFormats: ['.gif', '.jpg', '.jpeg', '.png', '.svg'],
                    uploadAsset: uploadAsset,
                    uploadComplete: uploadComplete
                }
            }, ref: ref, 
            // @ts-expect-error FIXME: Property 'componentFirst' does not exist on type 'selectorManagerConfig'.
            selectorManager: { componentFirst: true }, showOffsets: true, storageManager: { autoload: false }, styleManager: { sectors: [] }, width: 'auto' },
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: htmlContent } }))));
};
Editor.displayName = 'Editor';
const EditorWithRef = (0, react_1.forwardRef)(Editor);
exports.default = EditorWithRef;
